import { render, staticRenderFns } from "./CameraLocation.vue?vue&type=template&id=08840981&"
import script from "./CameraLocation.vue?vue&type=script&lang=js&"
export * from "./CameraLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CameraLocation.vue"
export default component.exports